import reducer from './reducer'

import * as facilityScreenSelectors from './selectors'

export { facilityScreenSelectors }

export default reducer
